var path = '/var/www/mmscny-website/src/app/components/planning-resources-fta-fact-sheets-circulars/planning-resources-fta-fact-sheets-circulars.html';
var html = "<reports-page-template details=$ctrl.details display-dropdown=false> </reports-page-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/planning-resources-fta-fact-sheets-circulars/planning-resources-fta-fact-sheets-circulars.html
// module id = 692
// module chunks = 0